<template>
  <v-app light>
    <link href="https://fonts.googleapis.com/css?family=Unica+One" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css?family=Quicksand" rel="stylesheet">
    <v-toolbar fixed color="primary" flat app clipped-left class="white">
      <v-toolbar-title>
        <router-link to="/">
        <svg width="60" height="60" viewBox="0 0 130 100">
          <circle cx="30" cy="30" r="18" fill="white"/>
          <polygon points="0,60 0, 65 10,65 10,100 120,100 120,65 130,65 130,60 80,10 70,40" fill="white"/>
        </svg>
        </router-link>
      </v-toolbar-title>
      <v-toolbar-title class="parent">
        <router-link class="parent" to="/">
          <span id="finquesCatalunyaTitle">
            IMMOBILIARIA CATALUNYA   
          </span>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <router-link to="/About">
        <span id="contactLink" v-if="$mq !== 'mobile'">Contacto</span>
        <v-icon v-if="$mq === 'mobile'" large color="white" class="mt-3"> 
contact_phone </v-icon>
      </router-link>
    </v-toolbar>
    <transition name="fade">
      <v-content>
        <router-view />
      </v-content>
    </transition>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      //
    };
  },
};
</script>

<style scoped>
a {
  color: "white";
}

#finquesCatalunyaTitle {
  margin-top:30px;
  color: white;

  font-size:28px;
}

.parent {
  margin-top: 25px;
}

@media (max-width: 540px) {
  #finquesCatalunyaTitle {
    font-size: 0.75em!important;
  }

  .parent {
    margin-top:0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

#contactLink {
  color: white;
}

svg {
  margin-top: 10px;
}

a {
  text-decoration:none;
}

span {
  font-weight: lighter;
  text-align:end;
}

@media (min-width: 324px) and (max-width: 1023px) {
  svg {
    height:50px;
    width:50px;
  }

  #finquesCatalunyaTitle{
    font-size:23px;
  }
}

@media (min-width:0px) and (max-width: 323px) {
    svg {
    height:30px;
    width:30px;
  }

  #finquesCatalunyaTitle{
    font-size:17px;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
